/* ============================================================
   THG · Precio dentro del boton de agregar al carrito
   ------------------------------------------------------------
   Funciona sin importar que archivo renderice el boton: busca el
   boton y el bloque de precio en la pagina de producto y copia el
   precio al boton. Como espeja el precio que el propio tema ya
   actualiza al cambiar de variante, nunca se desincronizan.

   Cargar desde layout/theme.liquid, antes de </body>:
     <script src="{{ 'thg-button-price.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  if (window.__thgBtnPrice) return;
  window.__thgBtnPrice = true;

  var BTN = '.hdt-product-form__submit';
  var PRICE_WRAP = '.hdt-product__price .hdt-price-wrapp, .hdt-product-info__item .hdt-price-wrapp';

  /* Contenedores donde NO se toca el boton: agregado rapido, vista rapida
     y cualquier modal. Ahi el tema ya muestra el precio y se duplicaria. */
  var SKIP = 'dialog, [id*="quick" i], [class*="quick" i], .hdt-dialog, .hdt-modal, hdt-quick-add, hdt-quickview';

  function isSkipped(btn) {
    if (btn.closest(SKIP)) return true;
    /* Si el texto del boton ya trae un numero con separador de miles,
       el tema ya puso el precio. */
    var txt = (btn.textContent || '').replace(/\s+/g, ' ');
    var mine = btn.querySelector('[data-thg-btn-price]');
    if (mine) txt = txt.replace(mine.textContent, '');
    return /\d[\d.,]{2,}/.test(txt);
  }

  /* Poner en false si quieres seguir viendo el precio arriba */
  var HIDE_ORIGINAL = true;

  /* Se oculta a la vista pero NO con display:none: el elemento tiene que
     seguir renderizado para que el tema lo siga actualizando al cambiar
     de variante, que es de donde leemos el precio. */
  function hideSource(wrap) {
    if (!HIDE_ORIGINAL || !wrap) return;
    var box = wrap.closest('.hdt-product-info__item') || wrap;
    if (box.dataset.thgHidden === '1') return;
    box.dataset.thgHidden = '1';
    box.style.position = 'absolute';
    box.style.width = '1px';
    box.style.height = '1px';
    box.style.margin = '-1px';
    box.style.padding = '0';
    box.style.overflow = 'hidden';
    box.style.clip = 'rect(0 0 0 0)';
    box.style.clipPath = 'inset(50%)';
    box.style.whiteSpace = 'nowrap';
    box.style.border = '0';
  }

  function priceText(wrap) {
    if (!wrap) return '';
    var el = wrap.querySelector('hdt-price .hdt-money')
          || wrap.querySelector('.hdt-price .hdt-money')
          || wrap.querySelector('.hdt-money');
    return el ? el.textContent.trim() : '';
  }

  /* El bloque de precio del producto principal, dentro del mismo section */
  function findWrap(btn) {
    var scope = btn.closest('[id^="shopify-section"]') || document;
    return scope.querySelector(PRICE_WRAP) || document.querySelector(PRICE_WRAP);
  }

  function paint(btn) {
    if (btn.disabled) {
      var old = btn.querySelector('[data-thg-btn-price]');
      if (old) old.remove();
      return;
    }
    var wrap = btn.dataset.thgWrapFound === '1' ? btn.__thgWrap : findWrap(btn);
    if (!wrap) return;
    btn.__thgWrap = wrap;
    btn.dataset.thgWrapFound = '1';

    var price = priceText(wrap);
    if (!price) return;

    hideSource(wrap);

    var tag = btn.querySelector('[data-thg-btn-price]');
    if (!tag) {
      tag = document.createElement('span');
      tag.setAttribute('data-thg-btn-price', '');
      tag.setAttribute('aria-hidden', 'true');
      tag.style.whiteSpace = 'nowrap';
      btn.appendChild(tag);
    }
    tag.textContent = ' \u2013 ' + price;
  }

  function attach(btn) {
    if (btn.dataset.thgPriceInit === '1') return;
    if (isSkipped(btn)) { btn.dataset.thgPriceInit = 'skip'; return; }
    btn.dataset.thgPriceInit = '1';

    paint(btn);

    var wrap = btn.__thgWrap;
    if (wrap) {
      /* Se observa el bloque de precio del tema. Escribimos en el boton,
         que es otro elemento, asi que no hay realimentacion. */
      new MutationObserver(function () { paint(btn); })
        .observe(wrap, { childList: true, subtree: true, characterData: true });
    }

    /* El boton puede pasar a deshabilitado al elegir una variante agotada */
    new MutationObserver(function () { paint(btn); })
      .observe(btn, { attributes: true, attributeFilter: ['disabled'] });
  }

  function scan() {
    document.querySelectorAll(BTN).forEach(function (btn) {
      /* Si el boton viene clonado desde otro sitio, se limpia el rastro */
      if (btn.dataset.thgPriceInit !== '1' && btn.dataset.thgPriceInit !== 'skip') {
        var stray = btn.querySelector('[data-thg-btn-price]');
        if (stray) stray.remove();
      }
      attach(btn);
    });
  }

  scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  }

  ['variant:change', 'product:variant-change', 'shopify:section:load'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(scan, 80); });
  });

  /* El tema puede volver a pintar el formulario al cambiar de variante.
     Se re-escanea solo cuando aparece un boton sin inicializar. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    if (!document.querySelector(BTN + ':not([data-thg-price-init])')) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();